import { render, staticRenderFns } from "./ApprovalResultChart.vue?vue&type=template&id=2dad5912&scoped=true&"
import script from "./ApprovalResultChart.vue?vue&type=script&lang=js&"
export * from "./ApprovalResultChart.vue?vue&type=script&lang=js&"
import style1 from "./ApprovalResultChart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad5912",
  null
  
)

export default component.exports